import { configureStore } from '@reduxjs/toolkit'
import configurationReducer from './configuration.slice/configuration.slice'
import userReducer from './user.slice/user.slice'

export const store = configureStore({
  reducer: {
    configuration:configurationReducer,
    user:userReducer
  },
})

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch